import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  template: `<img [src]="params.value" alt="Symbol Image" width="50" height="50" style="cursor: pointer;" (click)="openPopup()" />
  <ng-template #AddMapConfigModal>
  <div class="p-grid p-fluid ">
        <div class="p-col-6 mt-3" >
          <h2 class="fw-bold"> Selected Image:</h2>
      </div>
      <div class="p-col-6" >
        <button mat-mini-fab mat-button mat-dialog-close color="warn" style="float:right;" pTooltip="Close" tooltipPosition="top">
          <i class="fa fa-times pb-1" style="color: #fff"></i>
        </button>
      </div>
      </div>
      <div class="center-image">
  <img [src]="params.value" alt="Symbol Image" style="width:40%" />
  </div>
  <ng-template>`,
  styles: [`
  .image-modal {
    text-align: center;
  }
  
  .center-image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
  }
  `]
}
)
export class BtnCellRendereImage implements ICellRendererAngularComp {
  @ViewChild('AddMapConfigModal') private AddMapConfigModal!: TemplateRef<any>;
  params: any;
  
  constructor(
    private dialog: MatDialog,
  ) {}

  agInit(params: any): void {
    this.params = params;
  }

  openPopup(): void {
    // const popupWindow = open('','_target', 'height=400,width=600');
    // popupWindow.document.write(`<img src="${this.params.value}" style="max-width: 100%;" />`);
    // popupWindow.document.close();
    this.dialog.open(this.AddMapConfigModal, {
      width: '60%', 
      height:'80%'   
    });
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}
